<svg:defs xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg">
	<filter height="130%"
			id="dropshadow">
		<feOffset result="offOut"
				  in="SourceAlpha"
				  dx="0"
				  dy="0"></feOffset>
		<feGaussianBlur result="blurOut"
						in="offOut"
						stdDeviation="5"></feGaussianBlur>
		<feBlend in="SourceGraphic"
				 in2="blurOut"
				 mode="normal"></feBlend>
	</filter>
</svg:defs>

<svg:g chart-axis xmlns:svg="http://www.w3.org/2000/svg"
	   [config]="axisConfig"></svg:g>

<svg:g xmlns:svg="http://www.w3.org/2000/svg"
	   [class.line]="config.type === 'line'"
	   [class.area]="config.type === 'area'"
	   [class.stacked]="config.isStacked"
	   (mousemove)="onMouseMoveMainChart($event)">
	<svg:g (mouseleave)="hoveredIndex=-1">
		<svg:g *ngFor="let line of lines;let i=index"
			   class="path-group"
			   [class.hover]="hoveredIndex==i"
			   (mouseover)="hoveredIndex=i">
			<!-- Overlapping (non-stacked) areas are translucent washes under a crisp stroke,
			     so series stay readable through each other; stacked areas remain opaque.
			     Fill and stroke are separate paths: the fill uses the closed envelope, the
			     stroke only the open data polyline — closing edges are never outlined. -->
			<svg:path *ngIf="line.fill !== 'none'"
					  class="path-fill"
					  [attr.fill]="line.fill"
					  [attr.fill-opacity]="config.isStacked ? 1 : 0.15"
					  stroke="none"
					  [attr.d]="line.path">
			</svg:path>
			<svg:path class="path"
					  fill="none"
					  [attr.stroke]="line.color"
					  [attr.d]="line.strokePath"
					  [attr.stroke-width]="'2px'"
					  stroke-linejoin="round"
					  stroke-linecap="round">
			</svg:path>
			<svg:g class="points">
				<svg:g *ngFor="let point of points[i];let j=index">
					<!-- Full-height strip centred on the point: tracks the hovered column with no
					     gaps and no overhang past the last point. -->
					<svg:rect [attr.x]="point.x - xStep/2"
							  [attr.y]="0"
							  [attr.width]="xStep"
							  [attr.height]="config.chartHeight"
							  fill-opacity="0"
							  stroke="#999"
							  stroke-width="0"
							  (mouseleave)="hoveredPointIndex=-1"
							  (mouseover)="hoveredPointIndex=j">
					</svg:rect>
					<!-- Ringed points on line AND area (a halo in the surface colour lifts markers
					     off the stroke); options.drawPoints=false hides them except on hover. -->
					<svg:g *ngIf="config.drawPoints !== false || hoveredPointIndex==j">
						<svg:circle [attr.cx]="point.x"
									[attr.cy]="point.y"
									r="3.5"
									[attr.fill]="point.color"
									stroke="var(--cs-surface, #fff)"
									stroke-width="1.5"
									class="point"
									[class.hover]="hoveredPointIndex==j">
						</svg:circle>
					</svg:g>
				</svg:g>
			</svg:g>
		</svg:g>
	</svg:g>

	<svg:g *ngIf="mousePosition">
		<svg:line class="guide-line"
				  [attr.x1]="mousePosition.x"
				  [attr.x2]="mousePosition.x"
				  y1="0"
				  [attr.y2]="axisConfig.e.y"
				  stroke="#555"
				  stroke-width="1px"
				  pointer-events="none"></svg:line>
	</svg:g>

	<!-- Tooltip targets: one fat invisible circle per data point, rendered LAST so no
	     series' full-height tracking rect can sit on top of them. The popover anchors
	     to the circle, so it opens beside the point. -->
	<svg:g class="hover-targets">
		<ng-container *ngFor="let series of points; let i = index">
			<svg:circle *ngFor="let point of series; let j = index"
						[attr.cx]="point.x"
						[attr.cy]="point.y"
						r="14"
						fill="transparent"
						pointer-events="all"
						container="body"
						[ngbPopover]="pointTooltips[j]"
						popoverTitle="{{config.data.labels[j]}}"
						triggers="mouseenter:mouseleave"
						(mouseleave)="hoveredPointIndex=-1"
						(mouseover)="hoveredPointIndex=j">
			</svg:circle>
		</ng-container>
	</svg:g>
</svg:g>


<!-- Series legend — top-right at the axis end, matching the bar chart. -->
<svg:svg class="legend-container"
		 xmlns:svg="http://www.w3.org/2000/svg"
		 *ngIf="config.showLegend"
		 x="0"
		 y="0"
		 height="100%">
	<svg:text text-anchor="end"
			  [attr.x]="config.chartWidth - config.xPadding - xOffsets"
			  y="12"
			  font-size="11"
			  font-weight="600"
			  letter-spacing="0.02em">
		<svg:tspan *ngFor="let line of lines;let i=index"
				   (mouseover)="hoveredIndex=i"
				   [attr.class]="hoveredIndex === i? 'legend hover':'legend'"
				   [attr.fill]="line.color">
			<svg:tspan>●&nbsp;</svg:tspan>
			<svg:tspan>{{line.label}}</svg:tspan>
			<svg:tspan *ngIf="i < lines.length - 1" dx="14">&nbsp;</svg:tspan>

		</svg:tspan>
	</svg:text>


</svg:svg>
